module.exports = __webpack_public_path__ + "img/vegetable-leeks-350x184.1fdc8afc.jpg";